// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "c4.umd.min." + {"49":"locale-bg-js","465":"locale-sl-js","506":"locale-es-js","661":"locale-en-js","723":"locale-it-js","738":"locale-fr-js"}[chunkId] + ".js";
};